import { render, staticRenderFns } from "./PersonalCabinet.vue?vue&type=template&id=7b864407&scoped=true&"
import script from "./PersonalCabinet.vue?vue&type=script&lang=js&"
export * from "./PersonalCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b864407",
  null
  
)

export default component.exports